import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Paper } from "@mui/material";
import { MuiMarkdown_V2 } from "../Shared/components/MuiMarkdown/MuiMarkdown_V2";
import { useThankYou } from "./useThankYou";
export const ThankYouPage = () => {
    const { thankYouMarkdown } = useThankYou();
    return (_jsx(Box, Object.assign({ maxWidth: "max-content", alignSelf: "center" }, { children: _jsx(Paper, { children: _jsx(Box, Object.assign({ p: 3 }, { children: _jsx(MuiMarkdown_V2, { children: thankYouMarkdown }) })) }) })));
};
